import * as stylex from "@stylexjs/stylex";
import { forwardRef } from "react";

import type {
  HallowElement,
  HallowElementProps,
  WithAsChild,
  WithStylexArray,
} from "../../../../types";
import { determineElementFromAsChild } from "../../../../utils";

const hallowElement: HallowElement = "div";

const styles = stylex.create({
  determinedElement: {
    display: "flex",
    flexDirection: "column",
  },
});

export type StackProps = { gap?: string } & WithAsChild<
  WithStylexArray<HallowElementProps<typeof hallowElement>>
>;

export const Stack = forwardRef<any, StackProps>(
  ({ asChild = false, children, styleXArray, gap, ...props }, ref) => {
    const DeterminedElement = determineElementFromAsChild({
      asChild,
      hallowElement,
    });

    return (
      <DeterminedElement
        ref={ref}
        {...props}
        {...stylex.props(styles.determinedElement, styleXArray)}
        style={{ gap: gap ? gap : undefined }}
      >
        {children}
      </DeterminedElement>
    );
  },
);

Stack.displayName = "Stack";
